// extracted by mini-css-extract-plugin
export default {"hero-image":"content_hero-image__RNe2n","cta-box":"content_cta-box__0Xj4S","add-section":"content_add-section__zYPhX"};